export default __webpack_public_path__ + "static/media/dreamfest (9).7e681c17.jpg";